import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({ 
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'ng-template.[templateId]', })
export class TemplateDirective {
  @Input()
  templateId: string | undefined;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(public template: TemplateRef<any>) {}
}
